/**
 * Ayuda — Ventas → Cuentas
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_SAL_ACCOUNTS_ITEM = {
  id: 'accounts',
  screenId: 'adm-sal-accounts',
  label: 'Cuentas',
  description: 'Consultá cuentas corrientes y lo pendiente de cobro.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Esta pantalla concentra la información de deuda y movimientos de tus clientes en cuenta corriente, y los remitos que todavía no se facturaron. Tiene cuatro pestañas arriba; tocá cada una para cambiar de vista.',
      },
      {
        title: 'Las cuatro pestañas',
        bullets: [
          'Cuentas Corrientes — movimientos del cliente (facturas, cobros, notas) con saldo acumulado.',
          'Facturas Pendientes — facturas que aún no se cobraron por completo.',
          'Saldos Pendientes — resumen de cuánto debe cada cliente, sin entrar cliente por cliente.',
          'Remitos sin Facturar — remitos que todavía tienen mercadería o cantidades sin facturar.',
        ],
      },
      {
        title: 'Pestaña Cuentas Corrientes',
        intro: 'Para ver el historial de un cliente:',
        fields: [
          {
            label: 'Cliente',
            description: 'Buscá y elegí el cliente. Es obligatorio para consultar.',
          },
          {
            label: 'Tipo de Cuenta',
            description: '«Actual» muestra el estado al día de hoy. «A fecha» permite elegir una fecha y ver cómo estaba la cuenta en ese momento.',
          },
          {
            label: 'Fecha (solo en «A fecha»)',
            description: 'El día hasta el cual querés calcular movimientos y saldos.',
          },
          {
            label: 'Buscar',
            description: 'Carga la lista de movimientos y el total de saldo por moneda.',
          },
        ],
        paragraphs: [
          'Arriba de la lista ves el total adeudado por moneda (por ejemplo ARS 15000 - USD 200).',
          'Cada fila muestra: fecha, descripción del comprobante, moneda, importe del movimiento y columnas de saldo por moneda.',
          'Tocá una fila para abrir la factura o el recibo de cobro correspondiente.',
        ],
      },
      {
        title: 'Pestaña Facturas Pendientes',
        intro: 'Lista facturas con saldo sin cobrar:',
        fields: [
          {
            label: 'Cliente (opcional)',
            description: 'Dejalo vacío para ver pendientes de todos los clientes, o elegí uno.',
          },
          {
            label: 'Tipo de Cuenta',
            description: '«Actual» o «A fecha», igual que en Cuentas Corrientes.',
          },
          {
            label: 'Ordenado Por',
            description: 'Ordená por Fecha o por Monto pendiente.',
          },
          {
            label: 'Buscar',
            description: 'Muestra la lista y el total pendiente por moneda arriba.',
          },
        ],
        bullets: [
          'Columnas: Fecha, Descripción (tipo y número de factura), Moneda, Monto total, Cobrado y Saldo pendiente.',
          'Tocá una fila para ver el detalle de esa factura.',
        ],
      },
      {
        title: 'Pestaña Saldos Pendientes',
        intro:
          'Al entrar se carga sola una lista de todos los clientes que tienen deuda, con el monto por moneda. Arriba ves los totales generales por moneda. No hace falta elegir cliente ni buscar: es un panorama rápido de quién debe y cuánto.',
        bullets: [
          'Columnas: Cliente, Moneda, Monto pendiente.',
        ],
      },
      {
        title: 'Pestaña Remitos sin Facturar',
        intro:
          'Al entrar se carga la lista de remitos que todavía tienen cantidades sin facturar. Podés dejar los filtros vacíos para verlos todos, o acotar la búsqueda.',
        fields: [
          {
            label: 'Cliente (opcional)',
            description: 'Dejalo vacío para ver remitos de todos los clientes, o elegí uno.',
          },
          {
            label: 'Fecha Desde / Fecha Hasta (opcionales)',
            description: 'Limitá el período del remito. Podés usar solo una de las dos fechas.',
          },
          {
            label: 'Buscar',
            description: 'Vuelve a cargar la lista con los filtros elegidos.',
          },
        ],
        bullets: [
          'Columnas: Fecha, Cliente, Comprobante, Moneda e Importe.',
          'El importe es lo que queda por facturar (cantidad pendiente por precio de cada línea).',
          'Si el remito no tiene precios cargados, el importe dice «Sin precio». Si solo algunas líneas tienen precio, el importe dice «(parcial)».',
          'Arriba ves el total valorizado por moneda. Los remitos sin precio no entran en ese total.',
          'Tocá una fila para abrir el remito.',
        ],
      },
    ],
  },
}
